import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { StoreModule, ActionReducer, MetaReducer } from '@ngrx/store';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppRoutingModule } from './app-routing.module';
import { StoreRouterConnectingModule, routerReducer, NavigationActionTiming } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { CoreModule } from './modules/core/core.module';
import { localStorageSync } from 'ngrx-store-localstorage';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { NgChartsModule } from 'ng2-charts';

import { HttpBackend } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { AuthenticationModule } from './modules/authentication/authentication.module';
import { logoutSuccess, clearAllStates } from 'src/app/modules/authentication/store/auth/auth.actions';
import { DEFAULT_APP_CULTURE_CODE } from './modules/core/languages/language.model';
import { MultiTranslateHttpLoader } from './modules/core/languages/labels.loader';
import { NotificationPrefsModule } from './modules/notification-prefs/notification-prefs.module';

// *--- START REFACTORED AREA ---*
import { CoreComponents, CoreModule as AppCoreModule } from '@app/core';
// *--- END REFACTORED AREA ---*

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: [
      {
        management: [
          'datafeeds',
          'datasets',
          'security_groups',
          'statuses',
          'users',
          'workflow',
          'auth_connections',
          'organizations',
          'maps',
          'communications',
          'service_accounts'
        ]
      },
      { authentication: ['auth'] },
      { core: ['userProfile', 'userSettings'] },
      { notificationPrefs: ['notificationPrefs'] }
    ],
    rehydrate: true,
    removeOnUndefined: true
  })(reducer);
}

function logout(reducer) {
  return function (state, action) {
    const localState = action.type === logoutSuccess.type || action.type === clearAllStates.type ? undefined : state;
    return reducer(localState, action);
  };
}

const metaReducers: Array<MetaReducer<any, any>> = [logout, localStorageSyncReducer];

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    StoreModule.forRoot(
      {
        router: routerReducer
      },
      { metaReducers }
    ),
    StoreRouterConnectingModule.forRoot({
      navigationActionTiming: NavigationActionTiming.PostActivation
    }),
    // Uncomment the following, when you want to troubleshoot using the Redux Dev Tools
    // StoreDevtoolsModule.instrument({
    //   maxAge: 25,
    //   logOnly: false,
    //   features: {
    //     pause: true,
    //     lock: true,
    //     persist: false
    //   },
    //   actionsBlocklist: ['Statistics'],
    //   connectInZone: true
    // }),
    BrowserAnimationsModule,
    AppCoreModule.forRoot(),
    FlexLayoutModule,
    FormsModule,
    NgChartsModule,
    ReactiveFormsModule,
    CoreModule,
    AuthenticationModule,
    NotificationPrefsModule,
    NgxDocViewerModule,
    ClipboardModule,
    ...CoreComponents
  ],
  providers: [
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useClass: MultiTranslateHttpLoader,
        deps: [HttpBackend]
      },
      fallbackLang: DEFAULT_APP_CULTURE_CODE,
      lang: DEFAULT_APP_CULTURE_CODE
    })
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
